import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useDispatch } from "react-redux";
import { CustomFieldFilter } from "~/components/Filters/CustomFieldFilter/CustomFieldFilter";
import { FilterCard } from "~/components/Filters/FilterCard";
import { clearCustomFieldFilterValuesAction, removeFilterAction, setCustomFieldFilterLogicAction, setCustomFieldFilterValuesAction } from "~/store/filters/actions";
import { customFieldFilterLogicSelector, customFieldFilterValuesSelector } from "~/store/filters/selectors";
import { useAirSelector } from "~/utils/ReduxUtils";
export const BaseCustomFieldFilterCard = /*#__PURE__*/ memo((param)=>{
    let { customField, values, ...props } = param;
    const dispatch = useDispatch();
    const { id: customFieldId } = customField;
    const clearValues = useCallback(()=>{
        dispatch(clearCustomFieldFilterValuesAction({
            customFieldId
        }));
    }, [
        customFieldId,
        dispatch
    ]);
    const selectedLogic = useAirSelector((state)=>customFieldFilterLogicSelector(state, customFieldId));
    const selectedValues = useAirSelector((state)=>customFieldFilterValuesSelector(state, customFieldId));
    const onLogicChange = useCallback((logic)=>dispatch(setCustomFieldFilterLogicAction({
            customFieldId,
            logic
        })), [
        dispatch,
        customFieldId
    ]);
    const onSelectedValuesChanged = useCallback((values)=>dispatch(setCustomFieldFilterValuesAction({
            customFieldId,
            values
        })), [
        dispatch,
        customFieldId
    ]);
    const onRemoveFilter = (filter)=>{
        dispatch(removeFilterAction({
            filter
        }));
        clearValues();
    };
    return /*#__PURE__*/ _jsx(FilterCard, {
        currentFilter: "customField",
        currentCustomField: customField,
        onClearClick: clearValues,
        onRemoveFilter: onRemoveFilter,
        ...props,
        children: /*#__PURE__*/ _jsx(CustomFieldFilter, {
            values: values,
            onSelectedValuesChange: onSelectedValuesChanged,
            onLogicChange: onLogicChange,
            selectedLogic: selectedLogic,
            selectedValues: selectedValues
        })
    });
});
BaseCustomFieldFilterCard.displayName = "BaseCustomFieldFilterCard";
